import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { BankTransaction, BankTransactionCreate, BankTransactionFilter } from '../data/bankTransaction';

export function createBankTransactionService(client: AxiosInstance) {
  return createCrudService<BankTransaction, BankTransactionCreate, BankTransactionFilter>(client, '/BankTransaction', 'bankTransactionId');
}

export type BankTransactionService = CrudService<BankTransaction, BankTransactionCreate, BankTransactionFilter>;
